var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.icon !== undefined)?_c('gmap-marker',{staticClass:"m-dropplet",attrs:{"position":_vm.position,"icon":_vm.icon,"label":_vm.localLabel,"options":{
    zIndex: _vm.zIndex,
  }},on:{"mouseover":() => _vm.setLabel(),"mouseout":function($event){_vm.localLabel = undefined},"click":(e) => _vm.$emit('click', e),"rightclick":(e) => {
      _vm.$emit('contextmenu', e);
    }}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }